import React from "react";
import styled from "styled-components";

export default function ComponentLink({ dataLink }) {

  return (
    <Container className="container-link">
      <div className="btn-prize">
        <div className="chilren-button" />
        <div className="content-link">
          {dataLink.map((item) => {
            return (
              <div key={item.id} onClick={item.action} className="link-detail">
                  <img src={item.srcImg} alt="" className="link-img" height={item.height}/>
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 20px;

 .link-detail{
  position: relative;
  margin: 0 auto;
  top: -18px;
  cursor: pointer;
 }

  .btn-prize {
    background: linear-gradient(to bottom, #096ef5 0%, #6be1ff 100%) !important;
    height: 92px;
    border: 2px solid #6be1ff !important;
    width: 410px;
    padding: 0 10px;
    border-radius: 400px;
    position: relative;
    color: white !important;
  }

  .chilren-button {
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.34) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 40px;
    width: calc(100% - 16px);
    height: calc(100% - 16px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .content-link {
    display: grid;
    grid-template-columns: 50% 50%;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    font-weight: bold;
    position: relative;
    z-index: 23;
  }

  @media (min-width: 992px) {
    .link-detail:hover{
      scale: 1.02;
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 430px) {
    .btn-prize{
      width: 90% !important;
      height: 80px !important;
    }
  }
`;
